import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/icons/filter-icon.svg'
import _imports_1 from '../../../assets/icons/trade-network-search.svg'
import _imports_2 from '../../../assets/icons/trade-network-trader.svg'
import _imports_3 from '../../../assets/icons/trade-network-list.svg'
import _imports_4 from '../../../assets/icons/sort.svg'


const _withScopeId = n => (_pushScopeId("data-v-b331bf48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mobile__wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "All Filters", -1))
const _hoisted_4 = { class: "draft-project__filter" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_9 = { class: "draft-project-innertabs" }
const _hoisted_10 = { class: "two_icons" }
const _hoisted_11 = { class: "sort__wrapper sort_dropdown_wrapper" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sortby_btn" }, "Sort by test", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_14 = { class: "checked__wrapper" }
const _hoisted_15 = { class: "draft-project__filter desktop__wrapper" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_19 = {
  key: 0,
  class: "loader-container"
}
const _hoisted_20 = {
  key: 0,
  class: "top_project_listing"
}
const _hoisted_21 = { class: "top_list_details" }
const _hoisted_22 = { class: "project_main map_wrapper" }
const _hoisted_23 = {
  key: 0,
  class: "tw-absolute tw-bottom-[100px] tw-left-1/2 -tw-translate-1/2"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "map__container" }, null, -1))
const _hoisted_25 = {
  key: 1,
  class: "tw-flex tw-flex-col tw-justify-center tw-items-center tw-h-full tw-w-full tw-mt-[530px]"
}
const _hoisted_26 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_CommonLoader = _resolveComponent("CommonLoader")!
  const _component_ProjectCard = _resolveComponent("ProjectCard")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_ProjectListEmptyState = _resolveComponent("ProjectListEmptyState")!
  const _component_PropertyListComponent = _resolveComponent("PropertyListComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.projectListing.length)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "draft-project-container md:!tw-pb-16 scroll-container",
          onScroll: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => ($setup.onScroll && $setup.onScroll(...args)))
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_expansion_panels, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_expansion_panel, null, {
                  title: _withCtx(() => [
                    _hoisted_2,
                    _hoisted_3
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_expansion_panel_text, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_component_v_text_field, {
                            placeholder: "Search Project name, Type, Description",
                            class: "input_field",
                            "bg-color": "#fff",
                            variant: "outlined",
                            modelValue: $setup.filter.search,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.filter.search) = $event))
                          }, {
                            "prepend-inner": _withCtx(() => [
                              _hoisted_5
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_v_text_field, {
                            placeholder: "KT19 9JG",
                            class: "input_field",
                            "bg-color": "#fff",
                            variant: "outlined",
                            modelValue: $setup.filter.postcode,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.filter.postcode) = $event))
                          }, {
                            "prepend-inner": _withCtx(() => [
                              _hoisted_6
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_v_select, {
                            class: "input_field",
                            "bg-color": "#fff",
                            variant: "outlined",
                            placeholder: "Commercial / Residential",
                            "item-title": "text",
                            "item-value": "value",
                            clearable: ""
                          }, {
                            "prepend-inner": _withCtx(() => [
                              _hoisted_7
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_select, {
                            modelValue: $setup.filter.type,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.filter.type) = $event)),
                            class: "input_field",
                            "bg-color": "#fff",
                            variant: "outlined",
                            placeholder: "Project Type",
                            "item-title": "text",
                            "item-value": "value",
                            items: $setup.jobTypes,
                            clearable: ""
                          }, {
                            "prepend-inner": _withCtx(() => [
                              _hoisted_8
                            ]),
                            _: 1
                          }, 8, ["modelValue", "items"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", {
                class: _normalizeClass(["right_btn", { active: !$setup.isMapView }])
              }, [
                _createVNode(_component_v_btn, {
                  "prepend-icon": "mdi-view-grid",
                  variant: "text",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.isMapView = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Tile ")
                  ]),
                  _: 1
                })
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["right_btn", { active: $setup.isMapView }])
              }, [
                _createVNode(_component_v_btn, {
                  "prepend-icon": "mdi-map",
                  variant: "text",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.isMapView = !$setup.isMapView))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Map ")
                  ]),
                  _: 1
                })
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_v_menu, {
                persistent: true,
                "close-on-content-click": false
              }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_btn, _mergeProps(props, { class: "sort__btn" }), {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 2
                  }, 1040)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list, { class: "dropdown__sort sort_dropdown_inner" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filterOptions, (item) => {
                        return (_openBlock(), _createBlock(_component_v_list_item, {
                          key: item.value
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, { onClick: $setup.onClickFilterOption }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  icon: item.icon,
                                  width: "12"
                                }, null, 8, ["icon"]),
                                _createTextVNode(" " + _toDisplayString(item.label), 1),
                                _createElementVNode("span", _hoisted_14, [
                                  _createVNode(_component_v_icon, { icon: "mdi-check" })
                                ])
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  ($setup.isShowDatePicker)
                    ? (_openBlock(), _createBlock(_component_DatePicker, {
                        key: 0,
                        masks: $setup.masks,
                        class: "calendar__select calendar__select__custom",
                        modelValue: $setup.filter.dataRange,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.filter.dataRange) = $event)),
                        modelModifiers: { range: true },
                        mode: "date"
                      }, null, 8, ["masks", "modelValue"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_v_text_field, {
              placeholder: "Search Project name, Type, Description",
              class: "input_field",
              "bg-color": "#fff",
              variant: "outlined",
              modelValue: $setup.filter.search,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.filter.search) = $event))
            }, {
              "prepend-inner": _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_v_text_field, {
              placeholder: "KT19 9JG",
              class: "input_field",
              "bg-color": "#fff",
              variant: "outlined",
              modelValue: $setup.filter.postcode,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.filter.postcode) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_v_select, {
              class: "input_field",
              "bg-color": "#fff",
              variant: "outlined",
              placeholder: "Commercial / Residential",
              "item-title": "text",
              "item-value": "value",
              clearable: "",
              "menu-props": { contentClass: 'icon__text__select' }
            }, {
              "prepend-inner": _withCtx(() => [
                _hoisted_17
              ]),
              _: 1
            }),
            _createVNode(_component_v_select, {
              modelValue: $setup.filter.type,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.filter.type) = $event)),
              class: "input_field",
              "bg-color": "#fff",
              variant: "outlined",
              placeholder: "Project Type",
              items: $setup.jobTypes,
              "item-title": "text",
              "item-value": "value",
              clearable: "",
              "menu-props": { contentClass: 'icon__text__select' }
            }, {
              "prepend-inner": _withCtx(() => [
                _hoisted_18
              ]),
              _: 1
            }, 8, ["modelValue", "items"])
          ]),
          ($setup.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createVNode(_component_CommonLoader, { loading: $setup.isLoading }, null, 8, ["loading"])
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (!_ctx.isEmptyPropertiesList)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", null, _toDisplayString($setup.getProjectCount) + " Projects ", 1),
                        _createTextVNode(" | "),
                        _createElementVNode("div", null, _toDisplayString($setup.getProjectCount) + " Results ", 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(["top_project_listing_content", { show: $setup.isMapView }])
                }, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["full_container", { half_container: $setup.isMapView }])
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.projectListing, (item) => {
                        return (_openBlock(), _createBlock(_component_ProjectCard, {
                          key: item.id,
                          job: item,
                          onClick: ($event: any) => ($setup.onClickProject(item?.refId))
                        }, null, 8, ["job", "onClick"]))
                      }), 128))
                    ], 2),
                    ($setup.isLoadingMorePage)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _createVNode(_component_Loader, { show: $setup.isLoadingMorePage }, null, 8, ["show"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_24
                ], 2)
              ], 64))
        ], 32))
      : _createCommentVNode("", true),
    ($setup.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _createVNode(_component_Loader, { show: $setup.isLoading }, null, 8, ["show"])
        ]))
      : _createCommentVNode("", true),
    (!$setup.getProjectCount && !$setup.isLoading && !$setup.isSearch && !$setup.isOpenNewProject)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createVNode(_component_ProjectListEmptyState, {
            onOpenNewProject: $setup.openNewProject,
            "allow-button": true,
            "heading-text": "completed"
          }, null, 8, ["onOpenNewProject"])
        ]))
      : _createCommentVNode("", true),
    ($setup.isOpenNewProject)
      ? (_openBlock(), _createBlock(_component_PropertyListComponent, {
          key: 3,
          onOnClickBackButton: $setup.onClickBackButton
        }, null, 8, ["onOnClickBackButton"]))
      : _createCommentVNode("", true)
  ], 64))
}